import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { kebabCase } from "lodash-es";

import machine from "../stateMachine";
import Form from "../components/Form";
import Step from "../components/Step";
import Navigation from "../components/Navigation";
import GoogleWidget from "../components/GoogleWidget";
import useStateMachine from "../hooks/useStateMachine";
import useNavigationSync from "../hooks/useNavigationSync";
import calculatePenalty from "../lib/calculatePenalty";
import * as trackingService from "../services/tracking";

const Calculator = () => {
  const form = useForm();
  const { currentState, send, goBack } = useStateMachine(machine);
  const values = form.watch();
  const isInitialStep = currentState.key === "START";

  const drivingPenalty = useMemo(() => {
    return calculatePenalty(values);
  }, [values]);

  const handleSubmit = (data) => {
    send(data);
  };

  const slug = `/${kebabCase(currentState.key)}`;
  useNavigationSync({
    slug,
    stepKey: currentState.key,
    values,
    handleSubmit,
    goBack,
  });

  const onInputChange = (key, value) => {
    const isSingleQuestion = currentState.questions.length === 1;
    if (isSingleQuestion) {
      const values = form.getValues();
      handleSubmit(values);
    }

    if (isInitialStep) trackingService.trackStart();
  };

  const shouldDisplayNavigation = !isInitialStep;

  return (
    <Form form={form}>
      <Step
        step={currentState}
        result={drivingPenalty}
        onInputChange={onInputChange}
        onSubmit={handleSubmit}
      />
      {shouldDisplayNavigation ? (
        <Navigation onBackClick={goBack} />
      ) : (
        <GoogleWidget />
      )}
    </Form>
  );
};

export default Calculator;
